import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c3f5447"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "quizz-header" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = ["innerHTML"]

import Timer from './Timer.vue'
import ScreenPath from '../ScreenPath.vue'
import { QuizzType } from '@/types/Quizz'


export default /*#__PURE__*/_defineComponent({
  props: {
    quizzType: null,
    question: null,
    index: null,
    questionsLength: null,
    showJustification: { type: Boolean }
  },
  emits: ['onTimerEnd'],
  setup(__props: any, { emit }) {

const props = __props as {
  quizzType: QuizzType
  question: string
  index: number
  questionsLength: number
  showJustification: boolean
}





function onTimerEnd() {
  emit('onTimerEnd')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ScreenPath, {
        "module-name": "Quiz",
        "final-path": `Question ${props.index}/${__props.questionsLength}`
      }, null, 8, ["final-path"]),
      _createElementVNode("h1", {
        innerHTML: _ctx.$t(props.question)
      }, null, 8, _hoisted_3)
    ]),
    (!props.showJustification)
      ? (_openBlock(), _createBlock(Timer, {
          key: 0,
          "quizz-type": props.quizzType,
          onOnTimerEnd: onTimerEnd
        }, null, 8, ["quizz-type"]))
      : _createCommentVNode("", true)
  ]))
}
}

})